<gen-immunotherapy
  class="compare-component"
  *ngIf="payload"
  [compareMode]="true"
  [config]="payload['config']"
  [values]="payload['updated']"
></gen-immunotherapy>
